<template>
  <TextInput
    :id="$attrs.id || 'complement'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'complement'"
    :label="$attrs.label || 'Complemento'"
    :placeholder="$attrs.placeholder || ''"
    :helper-message="
      $attrs.helperMessage ||
      'Informação opcional. Pode ser o número do apartamento, bloco, sala, quadra, lote, KM, etc.'
    "
    :validations="$attrs.value ? 'rgx:persona.residence.complement' : ''"
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'AddressComplementInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
